import styled from '@emotion/styled'
import WysiwygBase from '@/components/Wysiwyg'

import { mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 120rem;
  margin: 0 auto;
  padding: 0 15px;

  ${mediaMax.xs} {
    width: 90%;
  }
`

export const TextContainer = styled.div`
  width: 70%;

  ${mediaMax.md} {
    width: 75%;
  }

  ${mediaMax.xs} {
    width: 90%;
  }
`

export const GreenText = styled(WysiwygBase)`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.green};
  line-height: 1.875rem;

  &.uppercase {
    line-height: 1.625rem;
    text-transform: uppercase;

    ${mediaMax.xs} {
      line-height: 3.0rem;
    }
  }
`
